import React, { useRef } from "react";
import { useState, useEffect, useContext } from "react";
import { Button, Form, Alert, Table, Modal } from "react-bootstrap";

import PortalService from '../../../services/portal.service';
import StateContext from '../../../context/State';
import getArrayBufferFromFile from '../../../../../util/getArrayBufferFromFile';
import getIconForFileType from '../../../../../util/getIconForFileType';
import { DocumentsFromLawyerResponse, FileUploadModel } from "../../../types";


const UploadDocumentsOnDashboardComponent = () => {

    const { state } = useContext(StateContext);
    const portalService = new PortalService(state);
    const [sharedDocuments, setSharedDocuments] = useState<DocumentsFromLawyerResponse>(null);
    const [fileToBeUploaded, setFileToBeUploaded] = useState<FileUploadModel>(null);
    const [showModal, setShowModal] = useState(false);
    const [selectedDocument, setSelectedDocument] = useState('');

    const aRef = useRef(null);

    // eslint-disable-next-line
    useEffect(() => { getAllSharedDocuments() }, [])

    const getAllSharedDocuments = async (): Promise<void> => {
        try {
            const sharedDocumentsResponse: DocumentsFromLawyerResponse = await portalService.getClientPortalDocuments(state.portalId.toString())
            if (sharedDocumentsResponse) { setSharedDocuments(sharedDocumentsResponse) }
        } catch (e) {
            console.log('Unable to retreive shared documents: ', e)
        }
    }

    const handleDocumentClicked = async (docName: string): Promise<void> => {
        try {
            await portalService.getClientPortalDocumentFromLaywer(state.portalId.toString(), docName);
        } catch (e) {
            alert(e);
        }
    }

    const handleUploadDocument = async (): Promise<void> => {
        if (!fileToBeUploaded) {
            alert('You must upload a valid document before submitting.');
            return;
        }
        try {
            const arrayBuffer: any = await getArrayBufferFromFile(fileToBeUploaded.uploadedFile);
            await portalService.uploadDocument(arrayBuffer, state.portalId, state.appId, fileToBeUploaded.fileName, 'CPL');
            setFileToBeUploaded(null);
            if (aRef.current) {
                aRef.current.value = null;

            }
            getAllSharedDocuments();
        } catch (e) {
            console.log(e);
            alert('Problem uploading this document.')
        }
    }

    const handleFileUploadComponent = async (e: React.ChangeEvent<HTMLInputElement>): Promise<void> => {
        const files = Array.from(e.target.files);
        let uploadedFile: File;
        if (files) {
            if (files[0]) {
                uploadedFile = files[0];
                const fileName: string = uploadedFile.name;
                setFileToBeUploaded({ uploadedFile, fileName });
            }
        }
    }

    const handleDocumentDelete = (docName: string) => {
        setSelectedDocument(docName);
        setShowModal(true);
    };

    const handleConfirmDelete = (docName: string) => {
        confirmDocumentDelete(docName)
        setShowModal(false);
    };

    const handleCancelDelete = () => {
        setShowModal(false);
    };

    const confirmDocumentDelete = async (docName: string): Promise<void> => {
        try {
            const resp = await portalService.deleteClientPortalDocumentFromLawyer(state.portalId.toString(), docName);
            if (resp.data.success){
                setSharedDocuments(prevDocuments => ({
                    Docs: prevDocuments.Docs.filter((d) => d.Name.split("/").at(-1) !== docName)
                }));
            }
            else{
                alert(resp.data.code)
            }
        } catch (e) {
            console.log(e)
            alert('Could not delete document. Please refresh the page and try again.')
        }
    }

    return (
        <>
            <Form.Group>
                <Form.Label>Upload Document</Form.Label>
                <Form.Control
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => { handleFileUploadComponent(e) }}
                    className="form-upload"
                    type="file"
                    ref={aRef}
                />
            </Form.Group>

            <Button onClick={() => handleUploadDocument()}>
                Submit
            </Button>

            <br /> <br />
            <Form.Label>All Documents</Form.Label>

            <br />

            {
                sharedDocuments && sharedDocuments.Docs.length !== 0 ?
                    <Table striped hover>
                        <tbody>
                            {
                                sharedDocuments.Docs.map((doc) => {
                                    const tempArray = (doc.Name).split("/");
                                    const className = getIconForFileType(tempArray.at(-1));
                                    return (
                                        <tr key={doc.Name + '-document-shared'}>
                                            <td onClick={() => { handleDocumentClicked(tempArray.at(-1)) }} >
                                                <i className={className} style={{ padding: 5 }} />
                                                {tempArray.at(-1)}
                                            </td>
                                            <td className="text-right">
                                                <i onClick={ () => handleDocumentDelete(tempArray.at(-1)) } className="fa-regular fa-trash-can"></i>
                                            </td>
                                            <br />
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </Table>
                    :
                    <Alert>No documents added.</Alert>
            }

                    <Modal show={showModal} onHide={() => setShowModal(false)}>
                        <Modal.Header closeButton>
                            <Modal.Title>Delete Document</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            "{selectedDocument}" will no longer be shared with the client. Your client may have already downloaded this document. Are you sure you would like to remove it from ClientConnect?
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCancelDelete}>
                                Cancel
                            </Button>
                            <Button variant="primary" onClick={() => handleConfirmDelete(selectedDocument)}>
                                Confirm
                            </Button>
                        </Modal.Footer>
                    </Modal>
        </>
    )
}

export default UploadDocumentsOnDashboardComponent;
